{
  "date": "{when, date, day}",
  "time": "{when, time, clock}",
  "date_time": "{when, date, day} at {when, time, clock}",
  "tee_time": "Tee time {when, time, clock}",
  "days": "{count, plural, one {# day} other {# days}}",
  "hours": "{count, plural, one {# hour} other {# hours}}",
  "minutes": "{count, plural, one {# minute} other {# minutes}}"
}
